import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import rdHub1 from "./assets/1.png";
import rdHub2 from "./assets/2.png";
import rdHub3 from "./assets/3.png";
import rdHub4 from "./assets/4.png";
import rdHub5 from "./assets/5.png";
import rdHub6 from "./assets/6.png";
import HubCard from "./HubCard";
import styles from "./styles.module.scss";
import H3Font from "../../common/H3Font";
const RDHub = ({ openChat }) => {
    const rdCheckInCompleted = useSelector((state) => state.user.rd_check_in_completed);
    const history = useHistory();
    const rdHubCards = [
        {
            title: "View Product Use Guide",
            onClick: () => history.push("/app/howtolp/"),
            img: rdHub1,
            className: "account_hub_card",
            imgClassName: styles.product_use_image,
        },
        {
            title: "Complete RD Check In",
            onClick: () => {
                window.location.href = "/quiz-new/quiz_rd/";
            },
            img: rdHub2,
            rdQuiz: true,
        },
        {
            title: "Chat with an RD",
            onClick: () => openChat(),
            img: rdHub3,
        },
        {
            title: "Macronutrient Calculator",
            onClick: () => {
                history.push("/app/rd-tool/");
            },
            img: rdHub4,
            imgClassName: "",
        },
        {
            title: "Generate a 7-Day Meal Plan",
            onClick: () => {
                history.push("/app/new-meal-plan/");
            },
            img: rdHub5,
            imgClassName: "",
        },
        {
            title: "Explore the Blog",
            onClick: () => {
                window.location.href = "/blog/";
            },
            img: rdHub6,
        },
    ];
    return (_jsxs("div", { className: styles.hub_wrapper, children: [_jsx("div", { className: styles.title, children: _jsx(H3Font, { children: "Start your journey" }) }), _jsx("div", { className: styles.hub, children: _jsx("div", { className: styles.hub_cards, children: rdHubCards.map((item) => (_jsx(HubCard, { title: item.title, onClick: item.onClick, img: item.img, isCompleted: item.rdQuiz && rdCheckInCompleted }, item.title))) }) })] }));
};
export default RDHub;
